(function () {
    'use strict';

    angular
        .module('oddQuestionnaireTemplateModule')
        .controller('oddQuestionnaireTemplateQuestionListEditController', Controller);

    Controller.$inject = ['$scope', '$state', 'notificationService', 'oddQuestionnaireTemplateService'];

    function Controller($scope, $state, notificationService, oddQuestionnaireTemplateService) {
        var boxModelClone = angular.copy($scope.boxModel);
        var section = $scope.boxContext.questionnaireSection;

        $scope.moveTo = moveTo;

        $scope.ctrlCtxt = {};
        $scope.sortableOptions = {
            animation: 0,
            forceFallback: true,
            disabled: section.IsInCampaign,
            scroll: true,
            scrollSpeed: 20,
            scrollSensitivity: 30,
            onUpdate: onSortUpdate,
            handle: '.sortable-handle'
        };

        // Remove Page Break
        $scope.removePageBreak = function removePageBreak(component) {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.deletePageBreak(section.ODDBusinessUnitID, section.ODDQuestionnaireID,
                    section.ODDSectionID, component.ODDPageBreakID).then(function () {
                notificationService.notify('Page Break has been deleted');

                _.pull($scope.boxModel, component);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;

            });
        }

        // Remove Static Text
        $scope.removeStaticText = function removeStaticText(component) {
            $scope.ctrlCtxt.isLoading = true;
            return true;
            // todo  
            //return oddQuestionnaireTemplateService.deletePageBreak(section.ODDBusinessUnitID, section.ODDQuestionnaireID,
            //        section.ODDSectionID, component.ODDPageBreakID).then(function () {
            //            //to do 
            //            notificationService.notify('Static Text has been deleted');

            //            _.pull($scope.boxModel, component);
            //        }).finally(function () {
            //            $scope.ctrlCtxt.isLoading = false;
            //        });
        }


        // Remove Question
        $scope.removeQuestion = function removeQuestion(component) {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.deleteQuestion(section.ODDBusinessUnitID, section.ODDQuestionnaireID,
                    section.ODDSectionID, component.ODDQuestionID).then(function () {

                notificationService.notify('Question has been deleted');

                _.pull($scope.boxModel, component);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }

        // Duplicate Question
        $scope.duplicateQuestion = function duplicateQuestion(component) {

            $scope.ctrlCtxt.isLoading = true;

            // Set the order of the new element in the list
            var duplicateIndex = _.indexOf($scope.boxModel, component) + 1;
            
            var idList = _.map($scope.boxModel, 'ItemID');
            idList.splice(duplicateIndex, 0, -1);

            return oddQuestionnaireTemplateService.duplicateQuestion(section.ODDBusinessUnitID, section.ODDQuestionnaireID,
                        section.ODDSectionID, component, idList).then(function (data) {
                            $scope.boxModel.splice(duplicateIndex, 0, data);

                            notificationService.notify('Question has been duplicated');

                            var path = '';
                            var state = $state.current;

                            if (state.name === "odd.surveyCampaignEdit.section.editComponentList") {
                                path = 'odd.surveyCampaignEdit.section.questionEdit';
                            }
                            else {
                                path = 'odd.questionnaireTemplatesEdit.questionnaire.section.question.edit';
                            }
                                
                            $state.go(path, {
                                ODDQuestionnaireID: section.ODDQuestionnaireID,
                                ODDQuestionnaireSectionID: section.ODDSectionID,
                                ODDQuestionID: data.ODDQuestionID
                            });

                        }).catch(function () {
                            notificationService.warn('An error occured while duplicating the question');
                        }).finally(function () {
                            $scope.ctrlCtxt.isLoading = false;
                        });
        }


        function moveTo(item, direction) {
            _.pull($scope.boxModel, item);

            if (direction === 'top') {
                $scope.boxModel.unshift(item);
            } else {
                $scope.boxModel.push(item);
            }

            onSortUpdate();
        }

        function onSortUpdate() {
            $scope.ctrlCtxt.isLoading = true;

            return oddQuestionnaireTemplateService.orderComponents(section.ODDBusinessUnitID, section.ODDQuestionnaireID,
                        section.ODDSectionID, $scope.boxModel).then(function() {

                notificationService.notify('Questions have been reordered');
                boxModelClone = angular.copy($scope.boxModel);
            }).catch(function() {
                $scope.boxModel = angular.copy(boxModelClone);
            }).finally(function () {
                $scope.ctrlCtxt.isLoading = false;
            });
        }
    }

})();